<template>
  <img crossorigin="anonymous" v-bind="$props" v-on="$listeners" />
</template>

<script>
export default {
  name: 'XoImg',
};
</script>
